export enum FeatureToggle {
  customersAndOrdersOrderDetailView = 'rt_cx_admin_migration_order_detail',
  customersAndOrdersCustomerSearchView = 'rt_cx_admin_migration_customer_search',
}
